import z from 'zod'

export const placeConfigSchema = z.object({
  rack: z.number().min(1, 'Numer regału musi być większy lub równy 1'),
  numberOfColumns: z.number().min(1, 'Liczba kolumn musi być większa lub równa 1'),
  numberOfShelfes: z.number().min(1, 'Liczba półek musi być większa lub równa 1'),
})

export type PlaceConfig = z.infer<typeof placeConfigSchema>
